import { render, staticRenderFns } from "./TextShrinker.vue?vue&type=template&id=614329f6"
import script from "./TextShrinker.vue?vue&type=script&lang=js"
export * from "./TextShrinker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports